import clsx from "clsx";

export const Heading = ({
  as: Comp = "h1",
  size = "4xl",
  children,
  className,
}) => {
  return (
    <Comp
      className={clsx(
        "font-serif font-normal tracking-tight",
        size === "5xl" && "text-5xl md:text-6xl",
        size === "4xl" && "text-3xl md:text-5xl",
        size === "3xl" && "text-3xl",
        size === "2xl" && "text-2xl",
        size === "xl" && "text-xl",
        className,
        "!leading-snug"
      )}
    >
      {children}
    </Comp>
  );
};
